import FileInput from '@/components/content/FileInput'
import { colors } from '@/styles/theme'
import { PageSizeSelect, SearchBarWrapper } from './gridV2_styles'
import { Textfield, SecondaryButton, Select, Typography, IconButton } from '@musinsa/layer-components-desktop'
import Button from '../content/Button'
import { Icon } from '@musinsa/pbo-assets'
import { HStack } from '@musinsa/mwms-ds'

// 개별 툴바 아이템 컴포넌트들
export const SearchBar = ({
  value,
  onChange,
  placeholder = '테이블 검색',
  iconSize = 24,
}: {
  value: string
  onChange: (v: string) => void
  placeholder?: string
  iconSize?: number
}) => {
  return (
    <SearchBarWrapper>
      <Textfield.Box style={{ height: '36px' }}>
        <Textfield.Slot>
          <Icon name="ic-search" size={iconSize} colorToken="fg-lower" style={{ flexShrink: 0, width: iconSize, height: iconSize }} />
        </Textfield.Slot>
        <Textfield.Input value={value} onValueChange={onChange} placeholder={placeholder} />
      </Textfield.Box>
    </SearchBarWrapper>
  )
}

export const Divider = () => <div style={{ width: '1px', height: '8px', backgroundColor: colors.gray300 }} />

export const ExportButton = ({ label = '전체 다운로드', disabled, onClick }: { label?: string; disabled?: boolean; onClick: () => void }) => (
  <SecondaryButton prefixIcon="ic-download" variant="outlined" label={label} size="small" disabled={disabled} onClick={onClick} />
)

export const UploadButton = ({
  disabled,
  onChange,
  accept = '.xlsx, .xls, .csv',
}: {
  disabled?: boolean
  onChange: (file: File) => void
  accept?: string
}) => <FileInput accept={accept} trigger={<Button fit kind="secondary" disabled={disabled} size="sm" content="업로드" />} onChange={onChange} />

export const DeleteButton = ({ onClick }: { onClick: () => void }) => <Button fit kind="gray" size="sm" content="삭제" onClick={onClick} />

export const AddButton = ({ label = '추가', onClick }: { label?: string; onClick: () => void }) => (
  <Button fit kind="primary_light" size="sm" content={label} onClick={onClick} />
)

export const Pagination = ({
  currentPage,
  totalPages,
  pageSize,
  pageSizeOptions,
  isAvailablePrevPage,
  isAvailableNextPage,
  onPrevPage,
  onNextPage,
  onPageSizeChange,
}: {
  currentPage: number
  totalPages: number
  pageSize: number
  pageSizeOptions: ReadonlyArray<{ label: string; value: number }> | Array<{ label: string; value: number }>
  isAvailablePrevPage: boolean
  isAvailableNextPage: boolean
  onPrevPage: () => void
  onNextPage: () => void
  onPageSizeChange: (size: number) => void
}) => (
  <HStack gap={8} align="center" justify="center">
    <Typography name="base-text-m" colorToken="fg">
      {currentPage + 1} / {totalPages || 1}
    </Typography>
    <HStack align="center" justify="center">
      <IconButton variant="ghost" icon="ic-chevronLeft" size="small" disabled={isAvailablePrevPage} onClick={onPrevPage} />
      <IconButton variant="ghost" icon="ic-chevronRight" size="small" disabled={isAvailableNextPage} onClick={onNextPage} />
    </HStack>
    <PageSizeSelect>
      <Select
        value={pageSize.toString()}
        onValueChange={(value) => onPageSizeChange(Number(value))}
        options={pageSizeOptions.map((option) => ({
          value: option.value.toString(),
          label: option.label,
        }))}
      />
    </PageSizeSelect>
  </HStack>
)
